import type { VariantProps } from 'class-variance-authority'

import { mergeProps } from '@base-ui/react/merge-props'
import { useRender } from '@base-ui/react/use-render'
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
    'group/badge inline-flex h-6 w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border border-transparent px-2.5 py-0.5 text-xs font-medium whitespace-nowrap transition-all focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 [&>svg]:pointer-events-none [&>svg]:size-3!',
    {
        variants: {
            variant: {
                default: 'bg-primary text-primary-foreground [a]:hover:bg-primary/80',
                secondary: 'bg-secondary text-secondary-foreground [a]:hover:bg-secondary/80',
                soft: 'bg-primary/10 text-primary [a]:hover:bg-primary/15',
                success: 'bg-success/12 text-success',
                warning: 'bg-warning/15 text-warning-foreground',
                ai: 'bg-ai/10 text-ai',
                destructive: 'bg-destructive/10 text-destructive [a]:hover:bg-destructive/20',
                outline: 'border-border bg-card text-foreground [a]:hover:bg-muted',
                ghost: 'hover:bg-muted hover:text-muted-foreground',
                link: 'text-primary underline-offset-4 hover:underline'
            }
        },
        defaultVariants: {
            variant: 'default'
        }
    }
)

function Badge({
    className,
    variant = 'default',
    render,
    ...props
}: useRender.ComponentProps<'span'> & VariantProps<typeof badgeVariants>) {
    return useRender({
        defaultTagName: 'span',
        props: mergeProps<'span'>(
            {
                className: cn(badgeVariants({ variant }), className)
            },
            props
        ),
        render,
        state: {
            slot: 'badge',
            variant
        }
    })
}

export { Badge, badgeVariants }
